import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet } from "../api/client";
import { streamPagePath } from "../pages/stream/StreamPage";
import "../styles.css";

export default function Footer() {
  const [streamNavPages, setStreamNavPages] = useState([]);

  useEffect(() => {
    apiGet('/stream-pages')
      .then((pages) => {
        const navPages = pages
          .filter((p) => p.showInNav)
          .sort((a, b) => (b.sortOrder || 0) - (a.sortOrder || 0));
        setStreamNavPages(navPages);
      })
      .catch(console.error);
  }, []);

  return (
    <footer className="animus-footer">
      <div className="container">
        <p className="animus-footer__rule font-mono">{'// NAVIGATION_MATRIX'}</p>
        <div className="footer-main">
          <div className="footer-logo">
            <h3>ZEMAXI</h3>
            <p>Streamer & Tool Creator</p>
          </div>
          <div className="footer-links">
            <div className="footer-nav">
              <h4 className="font-mono">NAV</h4>
              <div className="footer-nav-columns">
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About</Link></li>
                  <li><Link to="/stream">Stream</Link></li>
                  {streamNavPages.map((page) => (
                    <li key={page.slug}>
                      <Link to={streamPagePath(page.slug)}>{page.navLabel || page.title}</Link>
                    </li>
                  ))}
                  <li><Link to="/streamers">Streamers</Link></li>
                </ul>
                <ul>
                  <li><Link to="/reviews">Reviews</Link></li>
                  <li><Link to="/videos">Videos</Link></li>
                  <li><Link to="/tools">Tools</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>
            </div>
            <div className="footer-social">
              <h4 className="font-mono">CONNECT</h4>
              <ul>
                <li><a href="https://twitch.tv/zemaxi" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-twitch"></i> Twitch</a></li>
                <li><a href="https://youtube.com/@zemaxi" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-youtube"></i> YouTube</a></li>
                <li><a href="https://ko-fi.com/zemaxi" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-ko-fi"></i> Ko-fi</a></li>
                <li><a href="https://instagram.com/zemaxiirl" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i> Instagram</a></li>
                <li><a href="https://x.com/zemaxiirl" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-x-twitter"></i> X</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="font-mono">&copy; 2026 ZeMaxi. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
